const CustomResource = {
	univ_name: '한양대학교 ERCIA 로봇직업교육센터',
	site_title: '',
	sso_login: 'LMS ID/PW로 로그인합니다.',
	address1: '한양대학교 ERCIA 로봇직업교육센터',
	address2: '주소 : (15588) 경기도 안산시 상록구 한양대학로 55, 제1과학기술관 133호 / 전화번호 : 031-400-4823',
	contact: '홈페이지 관리자 : 한승수 연구원 (epxktmdnjem@hanyang.ac.kr)',
	copyright: 'Copyright 한양대학교 ERICA 로봇직업교육센터. All Rights Reserved.',
};

export default CustomResource;
